import { ComponentProps } from 'react';
import Profile from '@alltrails/communityapp/profile';
import '@alltrails/communityapp/dist/profile.css';
import CustomProvider from 'components/CustomProvider';
import usePathname from 'hooks/usePathname';

type Props = ComponentProps<typeof Profile>;

const ProfileApp = ({ context, profileOwner }: Props) => {
  const fullpath = usePathname();

  return (
    <CustomProvider>
      <Profile context={context} fullpath={fullpath} profileOwner={profileOwner} />
    </CustomProvider>
  );
};

export default ProfileApp;
